'use strict';

var _ = require('fox-helpers');

function XFormData() {
  this._values = {};
  this._files = {};
  this._fileChunkSize = 0; // means no split to chunks, send in one request
}

module.exports = XFormData;

XFormData.prototype = _.mixin({
  appendValue: function (name, value) {
    this._values[name] = value;
  },

  appendFile: function (name, file) {
    this._files[name] = file;
  },

  listValues: function () {
    return this._values;
  },

  listFiles: function () {
    return this._files;
  },

  getFileChunkSize: function (chunkSize) {
    return this._fileChunkSize;
  },

  setFileChunkSize: function (chunkSize) {
    this._fileChunkSize = chunkSize;
  }
}, Object.prototype);



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/scripts/xformdata.js
// module id = 107
// module chunks = 0